import * as Scrivito from "scrivito";

const TableWidget = Scrivito.provideWidgetClass("TableWidget", {
  attributes: {
    rows: ["widgetlist", { only: "TableRowWidget" }],
    summaryRows: ["widgetlist", { only: "TableRowWidget" }],
    headers: "stringlist",
    firstColumnAsHeader: "boolean",
    caption: "string",
    description: "string",
  },
  extractTextAttributes: ["rows", "summaryRows"],
});

export default TableWidget;
